import {createAction, props} from '@ngrx/store';

export class ConfirmDialogActions {
  public static open = createAction(
    '[Confirm-Dialog] Open confirm-dialog.',
    props<{
      title: string;
      text: string;
    }>(),
  );

  public static close = createAction('[Confirm-Dialog] Close confirm-dialog.');
}
